<template>
  <div id="dashboard-commission-interest">
    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <CommonFilters type="commissionInterest" :hide="['type']" @filterElements="filterElements" />
    </v-card>

    <v-row>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <CommissionsByMonth ref="commissionsByMonth" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="interestsByMonth" type="interest" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonFilters from '@/views/components/common/CommonFilters'
import OrdersByMonth from '@/views/components/dashboardDetail/orders/OrdersByMonth'
import CommissionsByMonth from '@/views/components/dashboardDetail/summary/CommissionsByMonth'

export default {
  components: {
    CommonFilters,
    OrdersByMonth,
    CommissionsByMonth,
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async filterElements(filters) {
      this.loading = true
      try {
        if (this.$refs.commissionsByMonth) this.$refs.commissionsByMonth.loadSummary(filters)

        if (this.$refs.interestsByMonth) this.$refs.interestsByMonth.loadSummary(filters)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>
